"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsDraggingWidget = void 0;
var tslib_1 = require("tslib");
var useDashboardDrop_1 = require("../useDashboardDrop");
function useIsDraggingWidget() {
    var _a = tslib_1.__read(useDashboardDrop_1.useDashboardDrop(["insightListItem", "kpi-placeholder", "insight-placeholder", "kpi", "insight"], {}, []), 1), isDraggingWidget = _a[0].canDrop;
    return isDraggingWidget;
}
exports.useIsDraggingWidget = useIsDraggingWidget;
//# sourceMappingURL=useIsDraggingWidget.js.map